@if (product?.alternativeReference ; as product) {
  <div class="TabBody">
    <div class="equivalent-product">
      <span class="equi-text"><img [src]="'/icons/warning.png'">
      {{'common.closest_equivalent_product_text'|cxTranslate}}</span>
    </div>
    <p class="equi-desc">{{'common.closest_equivalent_product_desc'|cxTranslate}}</p>
    <div class="col-12 col-sm-6 col-md-4 product-grid-item">
      @for ( key of product; track  key) {
        <app-pdp-tab-grid-item [product]="key?.['target']" class="closetImg"></app-pdp-tab-grid-item>
      }
    </div>
  </div>
}
